export default (oItem) => {
    oItem = oItem.target ?? oItem;
    const oCard = oItem.closest('.card');

    if (!oCard) {
        return;
    }

    oCard.removeAttribute('data-show-card-add');
    document.querySelector('html').removeAttribute('data-show-qv');
}
